import { Navigate } from 'react-router-dom';
import { getToken, isTokenExpired, clearAuth } from '../lib/auth.ts';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const token = getToken();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (isTokenExpired()) {
    clearAuth();
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
